import { rem } from 'polished';
import styled from 'styled-components';

export const StyledTitle = styled.h1`
  font-size: ${rem('28px')};
  font-weight: 600;
`;

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const StyledEmptyList = styled.div`
  width: 100%;
  padding: ${rem('24px')};
  border-radius: ${'16px'};
  color: ${({ theme }) => theme.colors.cross.grayson};
  text-align: center;
  border: ${rem('1px')} dashed ${({ theme }) => theme.colors.cross.silverFox};
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${rem('32px')};
  align-items: center;
  margin-bottom: ${rem('40px')};
  width: 100%;
`;

export const StyledListWrapper = styled.div`
  width: 100%;
`;
